import * as React from 'react';
import { Box } from '@lcifr/components/box';
import { Wrap as LuciferWrap } from '@lcifr/components/wrap';
import { Image } from 'components/Image';
import { sx } from '@lcifr/sx';
import { Anchor } from '@lcifr/components/anchor';
import { CollectionType } from '@lcifr/components/collection';
import Link from 'next/link';
import { Heading } from '@lcifr/components/heading';
import { useRawI18n } from '@lcifr/pages';
import { Button } from '@lcifr/components/button';
import { Icon } from '@lcifr/components/icon';
import { Stack } from '@lcifr/components/stack';
import { LinkStudio } from '@lcifr/components/link';
import { Section } from '@lcifr/components/section';

export const Stage = sx(Box)({
  background:
    'linear-gradient(180deg, rgba(15, 17, 37, 0.1) 0%, rgba(15, 17, 37, 0.03) 100%)',
});

type HeroTechnologyProps = {
  headline: any;
  subline: any;
  image: any;
  width: any;
  minHeight: any;
  bg: any;
  bgImage: any;
  spaceT: any;
  spaceB: any;
  stackSpace: any;
  id: any;
  vRhythm: any;
};

export function HeroTechnology({
  headline,
  subline,
  image,
  width,
  minHeight,
  bg,
  bgImage,
  spaceT,
  spaceB,
  stackSpace,
  id,
  vRhythm,
}: HeroTechnologyProps) {
  const technology = useRawI18n()?.pageTechnology;
  const backText = technology?.backText;
  const backLink = technology?.backLink;
  const moreText = technology?.moreText;
  const moreLink = technology?.moreLink;
  return (
    <Box sx={{ '> div > div': { pl: '0 !important', pr: '0 !important' } }}>
      <Section
        width="full"
        minHeight={minHeight}
        bg={bg}
        bgImage={bgImage}
        spaceT={spaceT}
        spaceB={spaceB || 8}
        stackSpace={0}
        id={id}
        vRhythm={vRhythm}
      >
        <Stage>
          <LuciferWrap width="normal">
            <Box
              sx={{
                display: 'grid',
                gridTemplateRows: '2fr 1fr',
                height: 'calc(100vh - 30px)',
                maxHeight: '1080px',
              }}
            >
              <Box
                sx={{
                  height: [
                    'calc(100% - 72px)',
                    'calc(100% - 72px)',
                    'calc(100% - 108px)',
                  ],
                  alignSelf: 'end',
                  position: 'relative',
                  boxSizing: 'border-box',
                }}
              >
                <Image
                  sx={{
                    verticalAlign: 'bottom',
                    img: {
                      objectFit: 'contain !important',
                    },
                  }}
                  className="heroProductsImage"
                  image={image}
                  alt="product"
                />
              </Box>
              <Box
                sx={{
                  alignSelf: 'center',
                  height: 'auto',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: ['column', 'column', 'row'],
                    justifyContent: 'space-between',
                    alignItems: ['flex-start', 'flex-start', 'flex-end'],
                    gap: ['24px', '24px', '40px'],
                    pb: 4,
                    flexShrink: 0,
                  }}
                >
                  <Box>
                    <Stack space={3}>
                      <LinkStudio link={backLink}>
                        <Button
                          variant="strippedPrimary"
                          sx={{
                            fontSize: '16px !important',
                            textTransform: 'uppercase',
                            letterSpacing: '3px',
                          }}
                        >
                          <Icon
                            name="chev-left"
                            sx={{ mr: 2, color: 'primary' }}
                          />
                          {backText}
                        </Button>
                      </LinkStudio>
                      <Heading variant="h1">{headline}</Heading>
                      <Heading variant="h4" sx={{ fontWeight: 400 }}>
                        {subline}
                      </Heading>
                    </Stack>
                  </Box>
                  <Box sx={{ width: 'auto', flexShrink: 0 }}>
                    <LinkStudio link={moreLink}>
                      <Button variant="bright">{moreText}</Button>
                    </LinkStudio>
                  </Box>
                </Box>
              </Box>
            </Box>
          </LuciferWrap>
        </Stage>
      </Section>
    </Box>
  );
}
